// Client mirror of functions/yearClosing/yearClosingReviewBasis.ts.
(function (global: any) {
// Only bookkeeping generated by closing itself is excluded from review freshness.
// Real postings, depreciation reversals and prior-year invalidation remain inputs.
const normalizeYearClosingReviewBasis = (basis: any, state: any) => {
  const list = (value: any): any[] => Array.isArray(value) ? value : []
  const entries = Object.values(state?.yearEndEntriesByYear || {}).flatMap(list)
  const ignored = new Set(entries.filter(entry => entry.source === 'year-closing-mutation-http'
    && ['corporate_tax_provision', 'deferred_tax', 'result_allocation'].includes(entry.kind)).map(entry => entry.id))
  for (const entry of entries) if (entry.source === 'year-closing-mutation-http'
    && entry.kind === 'year_closing_reversal' && ignored.has(entry.reversesEntryId)) ignored.add(entry.id)
  const result = { ...basis }
  if (Object.prototype.hasOwnProperty.call(result, 'reopenedAt')) result.reopenedAt = undefined
  for (const key of ['entries', 'yearEndEntries']) if (Array.isArray(result[key])) result[key] = result[key].filter((entry: any) => !ignored.has(entry.id))
  if (result.accountingRecordedSeqCounter != null) result.accountingRecordedSeqCounter = Math.max(0, Number(result.accountingRecordedSeqCounter) - ignored.size)
  const priorInvalidation = state?.yearClosingProcessByYear?.[String(basis.year)]?.invalidatedByPriorYear
  if (priorInvalidation != null) result.invalidatedByPriorYear = priorInvalidation
  return result
}
  global.PlummeYearClosingReviewBasis = { normalize: normalizeYearClosingReviewBasis }
})(window)
